import { BooleanField, TextField, TextFieldInputProps } from "@hex-insights/forms";
import { RadioRowInput } from "../../../Components/RadioRowInput";
import { PhoneNumberFormValues } from "../../FormUtilities";
import { PersonSelectField } from "../Person";
import { BaseFieldProps } from "../shared";

/**
 * Generic props for fields of the PhoneNumber model.
 */
type FieldProps<K extends keyof PhoneNumberFormValues.Base = keyof PhoneNumberFormValues.Base> = BaseFieldProps<
	Pick<PhoneNumberFormValues.Base, K>
>;

/**
 * Field component for the `name` field of the PhoneNumber model.
 */
export function Name({ formState, ...props }: FieldProps<"name">) {
	return <TextField formState={formState} name="name" optional Input={NameInput} {...props} />;
}

const nameOptions = [{ value: "Home" }, { value: "Mobile" }, { value: "Work" }];

function NameInput(props: TextFieldInputProps) {
	return <RadioRowInput options={nameOptions} {...props} className={undefined} />;
}

/**
 * Field component for the `phoneNumber` field of the PhoneNumber model.
 */
export function PhoneNumber({ formState, ...props }: FieldProps<"phoneNumber">) {
	return <TextField formState={formState} name="phoneNumber" {...props} />;
}

/**
 * Field component for the `isPrimary` field of the PhoneNumber model.
 */
export function IsPrimary({ formState, label = "Primary", ...props }: FieldProps<"isPrimary"> & { oneLine?: boolean }) {
	return <BooleanField formState={formState} name="isPrimary" label={label} {...props} />;
}

export namespace Person {
	export type SelectProps = FieldProps<"personID"> &
		Omit<PersonSelectField.SelectProps<PhoneNumberFormValues.Base>, "formState" | "name" | "optional">;

	/**
	 * Field component for the `person` edge of the PhoneNumber model.
	 */
	export function Select({ formState, ...props }: SelectProps) {
		return <PersonSelectField.Select formState={formState} name="personID" optional {...props} />;
	}
}
